import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledLentilsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.size.static350};
  
  div {
    background: transparent;
  }
`;
export const CustomGallerySlideWrapper = styled.div`
  & [class^='StyledContainedImageWrapper-'],
  & [class*=' StyledContainedImageWrapper-'] {
    width: ${({ theme }) => theme.size.grid020};
    @media (min-width: ${Breakpoints.b560}px) {
      width: ${({ theme }) => theme.size.grid018};
    }
    @media (min-width: ${Breakpoints.b960}px) {
      width: ${({ theme }) => theme.size.grid008};
    }
    @media (min-width: ${Breakpoints.b1280}px) {
      width: ${({ theme }) => theme.size.grid006};
    }
    @media (min-width: ${Breakpoints.b1600}px) {
      width: ${({ theme }) => theme.size.grid005};
    }
    @media (min-width: ${Breakpoints.b1920}px) {
      width: ${({ theme }) => theme.size.grid004};
    }
  }
`;

export const GalleryWrapper = styled.div`
  margin-top: ${({ theme }) => theme.size.static400};
  @media (min-width: ${Breakpoints.b960}px) {
    padding-left: ${({ theme }) => theme.size.grid002};
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    padding-left: ${({ theme }) => theme.size.grid001};
  }
  button[aria-label='To previous vehicle'] {
    @media (min-width: ${Breakpoints.b960}px) {
      margin-bottom: 130px;
    }
    
  }
  button[aria-label='To next vehicle'] {
    @media (min-width: ${Breakpoints.b960}px) {
      margin-right: 70px;
      margin-bottom: 130px;
    }
    @media (min-width: ${Breakpoints.b1280}px) {
      margin-right: 20px;
    }
  }
  ul {
    @media (min-width: ${Breakpoints.b560}px) {
      scroll-padding: 0 ${({ theme }) => theme.size.grid003};
      padding: 0 ${({ theme }) => theme.size.grid003};
    }
    @media (min-width: ${Breakpoints.b960}px) {
      scroll-padding: 0 ${({ theme }) => theme.size.grid005} 0 0;
      padding: 0 ${({ theme }) => theme.size.grid005} 0 0;
    }
    @media (min-width: ${Breakpoints.b1280}px) {
      scroll-padding: 0 ${({ theme }) => theme.size.grid003} 0 0;
      padding: 0 ${({ theme }) => theme.size.grid003} 0 0;
    }
    @media (min-width: ${Breakpoints.b1600}px) {
      scroll-padding: 0 ${({ theme }) => theme.size.grid002} 0 0;
      padding: 0 ${({ theme }) => theme.size.grid002} 0 0;
    }
  }
`;

export const StyledDesktopWrapper = styled.div`
  @media(min-width: ${Breakpoints.b1280}px) {
    padding-left: ${({ theme }) => theme.size.grid001};
  }
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.size.static350};
  margin-top: ${({ theme }) => theme.size.static400};
`;

export const StyledSlideWrapper = styled.div`
  width: ${({ theme }) => theme.size.grid004};
`;